import React, {
  useState,
  useContext
} from "react";
import {
  withRouter
} from "react-router";
import {
  makeStyles
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";
import AlertMui from "../core/AlertMui";
import ModalMui from "../core/ModalMui";
import TermsOfUseMui from "../core/TermsOfUseMui";
import TableContext from "../../context/table/tableContext";

import AlertContext from "../../context/alert/alertContext";
import ModalContext from "../../context/modal/modalContext";
import PortalContext from "../../context/portal/portalContext";
import AuthContext from "../../context/authentication/authContext";
import useMediaQuery from "../../hooks/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    height: "553px",
  },
  paper: {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    marginTop: "20px",
    marginLeft: "20px",
  },
  typography: {
    padding: theme.spacing(3),
    fontSize: "22px",
  },
  form: {
    marginTop: theme.spacing(1),
  },
  contentSubmit: {
    margin: theme.spacing(3, 0, 2),
    textAlign: "center",
  },
}));

const ReceiveNewVoucherToProcess = (props) => {
  const alertContext = useContext(AlertContext);
  const {
    alert,
    showAlert /* message */
  } = alertContext;
  const authContext = useContext(AuthContext);
  const { user, closeSession, hasToChange } = authContext;
  const portalContext = useContext(PortalContext);
  const { data } = portalContext;
  const modalContext = useContext(ModalContext);
  const { modalShow, showModal, closeModal } = modalContext;
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  /* useEffect(() => {
     if (message) {
      showAlert(message.msg, message.category);
    }
  }, [message]) */

  const {
    receiveNewVoucherToProcess
  } = authContext;

  const [receiveNewVoucherToProcessForm, setReceiveNewVoucherToProcessForm] = useState({
    voucherCode: ""
  });

  const [voucherCompanyType, setVoucherCompanyType] = useState(0); // Fixme ADV::: en caso de agregar otra integración esto debe quedar en ''

  const [loading, setLoading] = useState(false);

  const {
    voucherCode
  } = receiveNewVoucherToProcessForm;

  const classes = useStyles();
  const isMobile = useMediaQuery("max-width", 600);



  const onChange = (e) => {
    setReceiveNewVoucherToProcessForm({
      ...receiveNewVoucherToProcessForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleChange = (event) => {
    setVoucherCompanyType(event.target.value);
  };





  const onSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    try {
      const response = await receiveNewVoucherToProcess({
        voucherCompanyType: voucherCompanyType,
        voucherCode: voucherCode
      });

      if (response.responseCode === 0) {
        showAlert("Cupón recibido correctamente. Estamos procesando, de estar todo correcto podra observar el cupón aplicado en su portal en unos momentos.", "success");
        setTimeout(function () { window.location.href = "/app/home" }, 10000);
      } else {
        showAlert(response.responseMessage, "error");
      }
    } catch (error) {
      //console.log(error);
      showAlert("Ha ocurrido un error inesperado", "error");
    }

    setLoading(false);
  };

  return (
    <div className={classes.root}>
      <ModalMui
        modalShow={modalShow}
        showModal={showModal}
        closeModal={closeModal}
        modalTitle={modalTitle}
      >
        {modalContent}
      </ModalMui>
      <Grid item xs={12}>
        <Grid item xs={12} >
          <Typography className={classes.typography}> Ingresar nuevo cupón</Typography>

          <InputLabel id="voucher-company-label">Seleccionar origen del cupón</InputLabel>
          <Select
            fullWidth id="voucherCompany"
            labelId="voucher-company-label"
            id="voucher-company"
            value={voucherCompanyType}
            onChange={handleChange}
          >
            <MenuItem selected value={0}>Caja los andes</MenuItem>
            {/* <MenuItem value={1}>Fidelis</MenuItem> */}
          </Select>

          <TextField margin="normal"
            fullWidth id="voucherCode"
            label="Código del cupón"
            name="voucherCode"
            type="text"
            multiline
            rowsMax={5}
            InputLabelProps={
              {
                style: {
                  fontSize: "14px"
                }
              }
            }
            value={
              voucherCode
            }
            onChange={
              onChange
            }
          />

          <Paper className={classes.paper} >
            <form className={
              classes.form
            }
              style={{
                width: !isMobile ? "30%" : "100%"
              }
              }
              noValidate onSubmit={
                onSubmit
              } >

              {
                alert && < AlertMui message={
                  alert.msg
                }
                  type={
                    alert.category
                  }
                />} <Grid className={
                  classes.contentSubmit
                } > {
                  loading ? (<
                    CircularProgress />
                  ) : (<Button type="submit"
                    variant="contained"
                    color="primary"
                    className={
                      classes.submit
                    } >
                    Enviar cupón</Button>
                  )
                } </Grid>
            </form >
          </Paper>
        </Grid >
      </Grid>
    </div>
  );
};

export default withRouter(ReceiveNewVoucherToProcess);